import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { Trophy } from '../../trophies.model';
import { ThemingService } from '@app/shared/services/theming.service';
import { SharedModule } from '@app/shared/shared.module';
import { RoundProgressComponent } from '@app/shared/components/round-progress/round-progress.component';
import { DisplayComponent } from '@app/shared/components/display/display.component';

@Component({
  selector: 'slotcom-trophy',
  standalone: true,
  templateUrl: './trophy.component.html',
  styleUrl: './trophy.component.scss',
  imports: [SharedModule, RoundProgressComponent, DisplayComponent],
})
export class TrophyComponent implements OnInit {
  trophy = input<Trophy>();
  currentTrophyIndex = input<number>();
  trophyIndex = input<number>();
  trophyName = input<string>();

  private isTouch = false;
  showBlockedText = signal(false);

  checkIcon: string;
  lockIcon: string;

  private themingService = inject(ThemingService);

  ngOnInit(): void {
    this.checkIcon = this.themingService.getThemeAsset('none', 'check');
    this.lockIcon = this.themingService.getThemeAsset('none', 'lock');
  }

  trophyImage = computed(() => {
    if (this.trophyName()) {
      return this.themingService.getThemeAsset('none', `pl-trophy-${this.trophyName()}`);
    } else {
      return this.themingService.getThemeAsset('none', 'pl-trophy-wood');
    }
  });

  trophyNameCamelCase = computed(() => this.trophyName()[0].toUpperCase() + this.trophyName().substring(1));

  status = computed(() => {
    if (this.trophyIndex() === this.currentTrophyIndex() && this.trophy().current !== this.trophy().total) {
      return 'PROGRESSING';
    } else if (this.trophyIndex() <= this.currentTrophyIndex()) {
      return 'COMPLETED';
    } else {
      return 'BLOCKED';
    }
  });

  onPointerEnter(ev: PointerEvent) {
    if (ev.pointerType === 'touch') return;

    this.isTouch = false;
    this.showBlockedText.set(true);
  }

  onPointerLeave(ev: PointerEvent) {
    if (ev.pointerType === 'touch') return;

    this.showBlockedText.set(false);
  }

  onPointerDown(ev: PointerEvent) {
    this.isTouch = ev.pointerType === 'touch';
  }

  onClick() {
    if (this.isTouch) this.showBlockedText.update((v) => !v);
  }
}
